import Keycloak from 'keycloak-js';
import { config as appConfig } from '~/config';

const DEFAULT_KEYCLOAK_CONFIG = { url: '', realm: '', clientId: '' };
const keycloakInstance = new Keycloak(appConfig?.keycloak ?? DEFAULT_KEYCLOAK_CONFIG);

/** keycloak-js allows a single `init()` per instance; cache the promise for Strict Mode remounts. */
let keycloakInitPromise: Promise<boolean> | null = null;

export function initKeycloakOnce(): Promise<boolean> {
  if (keycloakInitPromise) {
    return keycloakInitPromise;
  }
  keycloakInitPromise = keycloakInstance.init({
    onLoad: 'check-sso',
    checkLoginIframe: false,
    pkceMethod: 'S256',
    silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
  });
  return keycloakInitPromise;
}

export default keycloakInstance;
